import React from 'react';
import { formatToMoney } from '../../utils/common';

const Resumen = ({data = [], bill={}}) => {
  
    const importe = data.reduce((actual, nuevo) => {
        return actual + nuevo.import;
    },0);

    const descuento  = data.reduce((actual, nuevo) => {
        return actual + nuevo.discount;
    },0);

    const iva = 0
    const total = data.reduce((actual, nuevo) => {
        return actual + nuevo.total;
    },0);

    const totalC$  = total * bill.rate;

    return (     
        <div className="float-right">
            <table>
                <tbody>

                <tr>
                    <td>Sub total:</td>
                    <td className="text-right">{formatToMoney(importe)}</td>
                </tr>
                <tr>
                    <td>Descuento:</td>
                    <td className="text-right">{formatToMoney(descuento)}</td>
                </tr>
                <tr>
                    <td>IVA:</td>
                    <td className="text-right">{formatToMoney(iva)}</td>
                </tr>
                <tr>
                    <td>Total:</td>
                    <td className="text-right"><b>{formatToMoney(total)}</b></td>
                </tr>              
                <tr>
                    <td>Total C$:</td>
                    <td className="text-right"><b>{formatToMoney(totalC$, 1)}</b></td>
                </tr>              
                </tbody>
            </table>
        </div>
    );
}

export default Resumen;
